import { render, staticRenderFns } from "./gj-expand-table.vue?vue&type=template&id=5aafa463&scoped=true&"
import script from "./gj-expand-table.vue?vue&type=script&lang=js&"
export * from "./gj-expand-table.vue?vue&type=script&lang=js&"
import style0 from "./gj-expand-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gj-expand-table.vue?vue&type=style&index=1&id=5aafa463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafa463",
  null
  
)

export default component.exports